// extracted by mini-css-extract-plugin
export default {"backgroundStyle":"AboutComp_backgroundStyle__fHpq0","imageSizing":"AboutComp_imageSizing__Wf9Ny","aboutTitle":"AboutComp_aboutTitle__ROdaA","aboutText":"AboutComp_aboutText__kAlc-"};